import React from 'react'
import bankSheetsLogo from '../assets/bank-sheets-icon-no-bg.png'

interface LogoProps {
  className?: string
  logoSize?: number
  textSize?: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
  showText?: boolean
}

const Logo: React.FC<LogoProps> = ({
  className = '',
  logoSize = 32,
  textSize = 'lg',
  showText = true,
}) => {
  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-md',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={bankSheetsLogo}
        alt="BankSheets Logo"
        width={logoSize}
        height={logoSize}
        className="flex-shrink-0"
      />
      {showText && (
        <span className={`font-semibold text-gray-900 ${textSizeClasses[textSize]}`}>
          BankSheets
        </span>
      )}
    </div>
  )
}

export default Logo
